import { render, staticRenderFns } from "./DashboardCard.vue?vue&type=template&id=323d2191&scoped=true&"
import script from "./DashboardCard.vue?vue&type=script&lang=js&"
export * from "./DashboardCard.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCard.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DashboardCard.vue?vue&type=style&index=1&id=323d2191&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323d2191",
  null
  
)

export default component.exports